import {
  REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST,
  REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS,
  REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE,
} from './types/InternalRepatriationsTransactionsCreateActionsTypes';

export function postRepatriationsTransactionsCreateRequestActionCreator(context,
  newDepartureDateTime,
  newDescription,
  newInboundImpc,
  newInboundOperator,
  newOutboundImpc,
  newOutboundOperator,
  newPlannedArrivalDateTime,
  newQuantity) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        departureDateTime: newDepartureDateTime,
        description: newDescription,
        inboundImpc: newInboundImpc,
        inboundOperator: newInboundOperator,
        outboundImpc: newOutboundImpc,
        outboundOperator: newOutboundOperator,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
      },
    },
  };
}

export function postRepatriationsTransactionsCreateSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS,
    payload: data,
  };
}

export function postRepatriationsTransactionsCreateFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
